import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import env from 'Env';
import postToStructuredData from 'Components/Utility/SEO/Blog/post-to-structured-data';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';
import { encodeSlug } from 'Helpers/Slug';
import { ScriptTag } from 'Helpers/SEO/Tags';


export default function BlogPostItemList({
  posts,
  nbHits,
  page,
  hitsPerPage,
  title,
  isMain,
}) {
  if (!posts || !posts.length) {
    return false;
  }

  let fullUrl = window.location.href.split('?')[0];

  if (getUrlParameter('page')) {
    fullUrl = `${fullUrl}?page=${getUrlParameter('page')}`;
  }

  let pageStart = 0;
  let numberOfItems = posts.length;

  if (nbHits) {
    numberOfItems = nbHits;
  }

  if (page && hitsPerPage) {
    pageStart = (page - 1) * hitsPerPage;
  }

  const schema = JSON.stringify({
    '@context': 'https://schema.org',
    '@id': `${fullUrl}#${encodeSlug(title) || 'blogposts'}-itemlist`,
    '@type': 'ItemList',
    numberOfItems,
    name: title || 'Blog Posts',
    mainEntityOfPage: isMain ? {
      '@id': `${fullUrl}#webpage`,
      '@type': 'CollectionPage',
    } : undefined,
    itemListElement: posts.map((post, i) => ({
      '@type': 'ListItem',
      position: i + 1 + pageStart,
      name: get(post, 'data.title[0].text', ''),
      item: env.enhanceItemLists ? postToStructuredData(post) : undefined,
      url: env.enhanceItemLists ? undefined : `${env.appProtocol}://${env.appUrl}/${window.locale || 'en'}/blog/${post.uid}`,
    })),
  });

  return <ScriptTag id="blog-posts-schema" type="application/ld+json" script={schema} />;
}

BlogPostItemList.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  title: PropTypes.string,
  nbHits: PropTypes.number,
  page: PropTypes.number,
  hitsPerPage: PropTypes.number,
  isMain: PropTypes.bool,
};

BlogPostItemList.defaultProps = {
  title: '',
  isMain: false,
  nbHits: null,
  page: null,
  hitsPerPage: null,
};
